<template>
  <div
    v-if="show"
    class="fixed inset-0 z-[999] flex items-center justify-center bg-black/40 px-4"
    style="top: -64px; height: calc(100% + 64px);"
  >
    <div class="w-full max-w-3xl rounded-xl bg-white shadow-xl">
      <div class="flex items-center justify-between border-b border-neutral-200 px-6 py-4">
        <h2 class="text-lg font-semibold text-neutral-800">Editar Grupo</h2>
        <button
          class="text-neutral-400 hover:text-neutral-600"
          @click="$emit('close')"
        >
          ✕
        </button>
      </div>

      <div class="px-6 py-5 space-y-4">
        <div>
          <label class="block text-sm font-medium text-neutral-700 mb-2">
            Nombre del Grupo
          </label>
          <input
            :value="form.name"
            type="text"
            placeholder="Nombre del grupo"
            class="w-full rounded-md border border-neutral-300 px-3 py-2 text-sm text-neutral-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            @input="emitUpdate('name', $event.target.value)"
          />
        </div>

        <div>
          <label class="block text-sm font-medium text-neutral-700 mb-2">
            Descripción (Opcional)
          </label>
          <input
            :value="form.description"
            type="text"
            placeholder="Añade una descripción opcional..."
            class="w-full rounded-md border border-neutral-300 px-3 py-2 text-sm text-neutral-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            @input="emitUpdate('description', $event.target.value)"
          />
        </div>

        <div>
          <div class="flex items-center justify-between mb-2">
            <label class="block text-sm font-medium text-neutral-700">
              Alumnos del Grupo
            </label>
            <span class="text-xs text-neutral-500">
              {{ students.length }} estudiantes
            </span>
          </div>

          <div class="flex flex-wrap items-center justify-between gap-2 mb-3">
            <button
              class="rounded-md border border-neutral-200 px-3 py-2 text-sm text-neutral-700 hover:bg-neutral-50"
              @click="$emit('add-students')"
            >
              Añadir Estudiantes
            </button>
            <button
              class="rounded-md border border-red-200 px-3 py-2 text-sm text-red-600 hover:bg-red-50 disabled:opacity-60"
              :disabled="selectedStudentIds.length === 0"
              @click="removeSelected"
            >
              Quitar seleccionados
            </button>
          </div>

          <div class="overflow-x-auto rounded-xl border border-neutral-200">
            <table class="w-full text-left text-sm">
              <thead class="bg-neutral-50 text-neutral-600">
                <tr>
                  <th class="px-4 py-3">
                    <input
                      type="checkbox"
                      class="h-4 w-4"
                      :checked="isAllSelected"
                      @change="toggleSelectAll"
                    />
                  </th>
                  <th class="px-4 py-3">Estudiante</th>
                  <th class="px-4 py-3">Email</th>
                  <th class="px-4 py-3 text-right">Acciones</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="student in students"
                  :key="student.id"
                  class="border-t border-neutral-100 hover:bg-neutral-50"
                >
                  <td class="px-4 py-3">
                    <input
                      type="checkbox"
                      class="h-4 w-4"
                      :value="student.id"
                      v-model="selectedStudentIds"
                    />
                  </td>
                  <td class="px-4 py-3 font-medium text-neutral-700">
                    {{ student.name }}
                  </td>
                  <td class="px-4 py-3 text-neutral-500">{{ student.email }}</td>
                  <td class="px-4 py-3 text-right">
                    <button
                      class="inline-flex items-center justify-center rounded-md p-1 text-red-600 hover:bg-red-50 hover:text-red-700"
                      @click="$emit('remove-student', student.id)"
                      title="Quitar del Grupo"
                    >
                      <svg
                        class="h-4 w-4"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <path d="M3 6h18" />
                        <path d="M8 6V4h8v2" />
                        <path d="M6 6l1 14h10l1-14" />
                        <path d="M10 11v6" />
                        <path d="M14 11v6" />
                      </svg>
                    </button>
                  </td>
                </tr>
                <tr v-if="students.length === 0">
                  <td colspan="4" class="px-4 py-4 text-center text-sm text-neutral-500">
                    No hay estudiantes asignados a este grupo.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="flex justify-end gap-2 border-t border-neutral-200 px-6 py-4">
        <button
          class="rounded-md border border-neutral-300 px-4 py-2 text-sm text-neutral-700 hover:bg-neutral-50"
          @click="$emit('close')"
        >
          Cancelar
        </button>
        <button
          class="rounded-md bg-blue-600 px-4 py-2 text-sm text-white hover:bg-blue-700"
          @click="$emit('save')"
        >
          Guardar Cambios
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TeacherEditGroupModal",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      required: true,
    },
    students: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      selectedStudentIds: [],
    };
  },
  computed: {
    isAllSelected() {
      return this.students.length > 0 &&
        this.students.every((student) => this.selectedStudentIds.includes(student.id));
    },
  },
  watch: {
    students() {
      this.selectedStudentIds = [];
    },
    show(isVisible) {
      if (!isVisible) {
        this.selectedStudentIds = [];
      }
    },
  },
  methods: {
    emitUpdate(field, value) {
      this.$emit("update-field", { field, value });
    },
    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedStudentIds = [];
        return;
      }
      this.selectedStudentIds = this.students.map((student) => student.id);
    },
    removeSelected() {
      if (this.selectedStudentIds.length === 0) {
        return;
      }
      this.$emit("remove-selected", [...this.selectedStudentIds]);
      this.selectedStudentIds = [];
    },
  },
};
</script>
